/**
 * @fileoverview Configuração da store Redux da aplicação.
 * Centraliza o gerenciamento de estado global usando Redux Toolkit.
 *
 * @module Store
 * @since 1.0.0
 */

import { configureStore } from '@reduxjs/toolkit';
import productsReducer from './slices/productsSlice';
import authReducer from './slices/authSlice';
import cartReducer from './slices/cartSlice';
import favoritesReducer from './slices/favoritesSlice';
import userManagerReducer from './slices/userManagerSlice';
import roleManagerReducer from './slices/roleManagerSlice';
import promotionReducer from './slices/promotionSlice';
import categoryManagerReducer from './slices/categoryManagerSlice';
import brandManagerReducer from './slices/brandManagerSlice';
import hiperSyncReducer from './slices/hiperSyncSlice';
import productManagerReducer from './slices/productManagerSlice';
import landpageManagerReducer from './slices/landpageManagerSlice';
import cartSyncMiddleware from './middleware/cartSyncMiddleware';
import favoritesSyncMiddleware from './middleware/favoritesSyncMiddleware';
import mobilePersistenceMiddleware from './middleware/mobilePersistenceMiddleware';
import globalContextMiddleware from './middleware/globalContextMiddleware';
import globalDataPersistMiddleware from './middleware/globalDataPersistMiddleware';
import globalDataReducer from './slices/globalDataSlice';
import sessionReducer from './slices/sessionSlice';
/**
 * Store Redux configurada com Redux Toolkit.
 * Combina os reducers de produtos e autenticação em um estado global unificado.
 *
 * @type {import('@reduxjs/toolkit').EnhancedStore}
 */
export const store = configureStore({
  reducer: {
    products: productsReducer,
    auth: authReducer,
    cart: cartReducer,
    favorites: favoritesReducer,
    userManager: userManagerReducer,
    roleManager: roleManagerReducer,
    promotion: promotionReducer,
    categoryManager: categoryManagerReducer,
    brandManager: brandManagerReducer,
    hiperSync: hiperSyncReducer,
    productManager: productManagerReducer,
    landpageManager: landpageManagerReducer,
    globalData: globalDataReducer,
    session: sessionReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(
      cartSyncMiddleware, 
      favoritesSyncMiddleware,
      mobilePersistenceMiddleware,
      globalContextMiddleware,
      globalDataPersistMiddleware
    ),
});

export default store;
